/**
 * Workshop Participant Module routes
 * Mounted under the HomeNew layout (authenticated shell).
 * The single /workshop route hosts the full module; internal navigation
 * is handled by the dashboard shell via `vw` state (no sub-routes needed).
 */
const workshopRoutes = [
  {
    path: "/workshop",
    name: "WorkshopDashboard",
    meta: {
      auth: true,
      iscommontoshow: true,
      screen_code: "SCN_WORKSHOP",
      page_code: "SCN_WORKSHOP",
      page_type: "landing",
    },
    component: () => import("@/views/workshop/workshop_dashboard.vue"),
  },
  {
    path: "/workshop-admin",
    name: "WorkshopAdmin",
    meta: {
      auth: true,
      iscommontoshow: true,
      screen_code: "SCN_WORKSHOP_ADMIN",
      page_code: "SCN_WORKSHOP_ADMIN",
      page_type: "landing",
    },
    component: () => import("@/views/workshop/admin/WorkshopAdmin.vue"),
  },
];

export default workshopRoutes;
